import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableFooter, Paper } from "@mui/material";
import { formatAmount } from './../../helper';
import SectionHeader from '../../Pages/admin/shared/SectionHeader';

/* Shops Warehouse Delivery — detail view.

   Legacy shape, recovered from the compiled report page
   (Reports_MS_RPT_ShopsWarehouseDelivery in App_Web_qpy0hn5k.dll): a two-column
   "Name | Delivery" table with a bold Total row, over SUM(TDeliverAmount).

   "Name" is the shop or the warehouse depending on the Group By selector, matching the
   legacy `_cmbGroupBy` combo. Line counts are shown as a secondary figure to make an
   unexpected total easier to explain — legacy did not have this column. */

const headCell = { background: '#f1f1f1', color: '#111827', fontWeight: 600 };
const numCell = { textAlign: 'right' };
const footCell = { fontWeight: 800, textAlign: 'right', color: '#111827', background: '#ffefd6' };

class Detail extends Component {

    render() {
        const { ReportDetails = {} } = this.props;
        const rows = ReportDetails.rows || [];
        const groupLabel = ReportDetails.GROUP_BY === 'warehouse' ? 'Warehouse' : 'Shop';

        return (
            <section>
                <SectionHeader title={<>{ReportDetails.WAREHOUSE_NAME} &nbsp;|&nbsp; {this.props.WeekRange}</>} />

                <Row>
                    <Col md={12} >
                        <Paper>
                            <TableContainer className="report-table-container" >
                                <Table className="report-table pc-shrink-table" size="small" stickyHeader aria-label="shops warehouse delivery">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={headCell} >{groupLabel} Name</TableCell>
                                            <TableCell style={{ ...headCell, ...numCell }} >Lines</TableCell>
                                            <TableCell style={{ ...headCell, ...numCell }} >Delivery</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {rows.length === 0 &&
                                            <TableRow>
                                                <TableCell colSpan={3} style={{ textAlign: 'center' }} >
                                                    There were no results for matching criteria
                                                </TableCell>
                                            </TableRow>
                                        }

                                        {rows.map((row, idx) => (
                                            <TableRow key={idx} >
                                                <TableCell>{row.NAME}</TableCell>
                                                <TableCell style={numCell} >{row.LINES_COUNT}</TableCell>
                                                <TableCell style={numCell} >{formatAmount(row.DELIVERY)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>

                                    {rows.length > 0 &&
                                        <TableFooter>
                                            <TableRow>
                                                <TableCell style={{ ...footCell, textAlign: 'left' }} >Total</TableCell>
                                                <TableCell style={footCell} >
                                                    {rows.reduce((n, r) => n + (+r.LINES_COUNT || 0), 0)}
                                                </TableCell>
                                                {/* Server-side total, not a re-sum of the rows — so the figure
                                                    matches what warehouseBalance.php reports for the same window. */}
                                                <TableCell style={footCell} >{formatAmount(ReportDetails.TOTAL_DELIVERY)}</TableCell>
                                            </TableRow>
                                        </TableFooter>
                                    }
                                </Table>
                            </TableContainer>
                        </Paper>

                        {/* A few historic rows carry an unparseable week ("NaN-WNaN") and cannot be
                            placed in any range. Say so rather than letting the Total look complete. */}
                        {+ReportDetails.SKIPPED_ROWS > 0 &&
                            <div style={{ color: '#a32f2f', fontSize: '12px', padding: '8px 4px' }} >
                                {ReportDetails.SKIPPED_ROWS} delivery line{+ReportDetails.SKIPPED_ROWS === 1 ? '' : 's'} for
                                this warehouse {+ReportDetails.SKIPPED_ROWS === 1 ? 'has' : 'have'} no valid week recorded and
                                {+ReportDetails.SKIPPED_ROWS === 1 ? ' is' : ' are'} excluded from every week range.
                            </div>
                        }
                    </Col>
                </Row>
            </section>
        );
    }
}

export default Detail;
